import { render, staticRenderFns } from "./TypeIndicator.vue?vue&type=template&id=11716531&"
import script from "./TypeIndicator.vue?vue&type=script&lang=ts&"
export * from "./TypeIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports